export const reducer = (previousState = initialState, action) => {
  switch (action.type) {
    case 'SET_STEP':
      return {
        ...previousState,
        step: action.step,
      };
    case 'SET_FORM_DATA':
      return {
        ...previousState,
        formData: {
          ...previousState.formData,
          ...action.hash,
        },
      };
    case 'SET_APP_DATA':
      return {
        ...previousState,
        appData: {
          ...previousState.appData,
          ...action.hash,
        },
      };
    case 'SET_META_DATA':
      return {
        ...previousState,
        metadata: {
          ...previousState.metadata,
          ...action.hash,
        },
      };
    case 'BACK_TO_STEP1':
      return {
        ...previousState,
        formData: {
          ...previousState.formData,
          ...action.hash,
        },
        step: action.step,
      };
    case 'BACK_TO_STEP3':
      return {
        ...previousState,
        formData: {
          ...previousState.formData,
          ...action.hash,
        },
        step: action.step,
      };
    case 'SHOW_MODAL':
      return {
        ...previousState,
        showModal: action.showModal,
      };
    case 'SHOW_LEAKING_MODAL':
      return {
        ...previousState,
        showLeakingModal: action.showLeakingModal,
      };
    case 'SET_IS_FETCHING':
      return {
        ...previousState,
        isFetching: action.isFetching,
      };
    case 'DISABLE_SUBMIT_BTN':
      return {
        ...previousState,
        disableSubmitBtn: action.disableSubmitBtn,
      };
    default:
      return previousState;
  }
};
